import React from "react";
import GridTable from "pages/_components/GridTable/GridTable";
import Accordion from "pages/_components/Accordion";
import { arrayOf, shape, string } from "prop-types";
import * as i18n from "util/i18n";
import AccordionItem from "pages/_components/AccordionItem";
import IndicatorsDetailCreditBills from "./_components/IndicatorsDetailCreditBills";
import Table from "./_components/CreditBillsTable";

const CreditBillsAccordion = ({ labels, data, numberToExpand, handleExpandEndorsement }) => {
    const getTableData = (label, tableData) => {
        switch (label) {
            case "indicadores":
                return <IndicatorsDetailCreditBills data={tableData} />;
            case "trasmiciones":
                return <Table data={tableData} />;
            default:
                return null;
        }
    };
    return (
        <>
            {labels.map((label, index) => (
                <div className="credit-bills__resumen box box-shadow">
                    <Accordion numberToExpand={numberToExpand}>
                        <AccordionItem
                            key={label}
                            number={index}
                            toggleAccordion={handleExpandEndorsement}
                            item={
                                <span>
                                    <span>{i18n.get(`credit.bills.detail.${label}.title`)}</span>
                                </span>
                            }>
                            <GridTable className="information informationBold">
                                {data[label] ? (
                                    getTableData(label, data[label])
                                ) : (
                                    <div className="mb-4">{i18n.get("echecks.accordion.noData")}</div>
                                )}
                            </GridTable>
                        </AccordionItem>
                    </Accordion>
                </div>
            ))}
        </>
    );
};

CreditBillsAccordion.propTypes = {
    labels: arrayOf().isRequired,
    data: arrayOf(shape({})).isRequired,
    numberToExpand: string.isRequired,
    handleExpandEndorsement: string.isRequired,
};

export default CreditBillsAccordion;
